"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sevenCreditsFrom: {
        '3-d modeling and animation': 1,
        'ac/dc electronics': 1,
        'accounting i': 1,
        'accounting ii': 1,
        'adv acting: shakespeare': 1,
        'adv actng/amr drama': 1,
        'adv broadcast journalism i': 1,
        'adv broadcast journalism ii': 1,
        'adv broadcast journalism iii': 1,
        'adv commercial photography': 1,
        'adv computer programming': 1,
        'adv constr mgt': 2,
        'adv graphic design & illust': 1,
        'adv hvac & refrigeration tech': 2,
        'adv journalism: newspaper i': 1,
        'adv journalism: newspaper ii': 1,
        'adv journalism: newspaper iii': 1,
        'adv journalism: yearbook i': 1,
        'adv journalism: yearbook ii': 1,
        'adv journalism: yearbook iii': 1,
        'adv lighting & stage design': 1,
        'adv plant & soil science': 1,
        'advanced animal science': 1,
        'advanced animation': 1,
        'advanced biotechnology': 1,
        'advanced culinary arts': 2,
        'advanced energy and natural resource technology': 1,
        'advanced health': 0.5,
        'advanced marketing': 2,
        'advanced quant reasoning': 1,
        'advanced transportation systems laboratory': 1,
        'advanced welding': 2,
        'lifetime rec/outdoor pursuits': 1,
        'aerobic activities': 0.5,
        'ag mech & metal tech': 1,
        'agribusiness mgt & marketing': 1,
        'agricultural equipment design and fabrication': 1,
        'agricultural laboratory and field experience': 1,
        'agricultural power sys': 2,
        'agricultural structures design and fabrication': 1,
        'aircraft airframe technology': 2,
        'aircraft powerplant technology': 2,
        'aircraft technology': 1,
        'algebra ii': 1,
        'algebraic reasoning': 1,
        'anatomy & physiology': 1,
        'animation i lab': 1,
        'animation ii lab': 1,
        'ap art/2-dim design portfolio': 1,
        'ap art/3-dim design portfolio': 1,
        'ap art/drawing': 1,
        'ap history of art': 1,
        'ap music theory': 1,
        'ap statistics': 1,
        'applied mathematics for technical professionals': 1,
        'applied music i': 1,
        'applied music ii': 1,
        'aquatic science': 1,
        'architectural design i': 1,
        'architectural design ii': 2,
        'art and media communications i': 1,
        'art dsgn & prod f/adv vis art': 1,
        'art i': 1,
        'art ii ceramics': 1,
        'art ii drawing': 1,
        'art ii electronic media-art2em': 1,
        'art ii fibers': 1,
        'art ii jewelry': 1,
        'art ii painting': 1,
        'art ii photography': 1,
        'art ii printmaking': 1,
        'art ii sculpture': 1,
        'art iii ceramics': 1,
        'art iii drawing': 1,
        'art iii electronic media': 1,
        'art iii fibers': 1,
        'art iii graphic design': 1,
        'art iii history': 1,
        'art iii jewelry': 1,
        'art iii painting': 1,
        'art iii photography': 1,
        'art iii printmaking': 1,
        'art iii sculpture': 1,
        'art iv ceramics': 1,
        'art iv drawing': 1,
        'art iv electronic media-art4em': 1,
        'art iv fibers': 1,
        'art iv graphic design-art4grap': 1,
        'art iv jewelry': 1,
        'art iv painting': 1,
        'art iv photography': 1,
        'art iv printmaking': 1,
        'art iv sculpture': 1,
        'art, departmentalized grade 6': 1,
        // 'art, grade 1': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 2': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 3': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 4': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 5': 1, // here because subject area is fine arts //deletion edit 2024
        'art, grade 6': 1,
        'art, grade 7': 1,
        'art, grade 8': 1,
        'audio video production': 1,
        'audio/video production i lab': 1,
        'audio/video production ii lab': 1,
        'automotive basics': 1,
        'automotive technology i: maintenance and light repair': 2,
        'automotive technology ii: automotive service': 2,
        'banking & financ svcs': 0.5,
        'basic collision repair and refinishing': 1,
        'building maint tech': 2,
        'building maintenance technology ii': 2,
        'busin info mgt i': 1,
        'busin info mgt ii': 1,
        'business english': 1,
        'business lab': 1,
        'business law': 1,
        'business management': 1,
        'career preparation i': 2,
        'career preparation ii': 2,
        'child development': 1,
        'child guidance': 2,
        'childrens theatre': 1,
        'college readiness & stdy skils': 0.5,
        'collision repair & refinish': 2,
        'commercial photography i lab': 1,
        'commercial photography ii lab': 1,
        'commercial photography': 1,
        'communication applications': 0.5,
        'computer maintenance lab': 1,
        'computer maintenance': 1,
        'computer programming': 1,
        'computer science i': 1,
        'computer science ii': 1,
        'computer science iii': 1,
        'computer technician practicum': 2,
        'computer technician': 1,
        'comtemp studies in dance i': 1,
        'comtemp studies in dance ii': 1,
        'comtemp studies in dance iii': 1,
        'comtemp studies in dance iv': 1,
        'construction management': 2,
        'construction technology ii': 2,
        'construction technology': 2,
        'contempory media': 1,
        'correctional services': 1,
        'cosmetology i': 2,
        'cosmetology ii': 2,
        'counsel & mental health': 1,
        'court sys & practices': 1,
        'creative writing': 1,
        'criminal investigation': 1,
        'culinary arts': 2,
        'dance & media communications i': 1,
        'dance i': 1,
        'dance ii': 1,
        'dance iii': 1,
        'dance iv': 1,
        'dance perform ensemble i': 1,
        'dance perform ensemble ii': 1,
        'dance perform ensemble iii': 1,
        'dance perform ensemble iv': 1,
        'debate i': 1,
        'debate ii': 1,
        'debate iii': 1,
        'diesel equipment technology i': 2,
        'diesel equipment technology ii': 2,
        'digital & interactive media': 1,
        'digital art and animation': 1,
        'digital audio technology i': 1,
        'digital audio technology ii': 1,
        'digital comm in the 21st cent': 1,
        'digital design & media prductn': 1,
        'digital electronics': 1,
        'digital forensics': 1,
        'digital video and audio design': 1,
        'directing for the stage': 1,
        'discovering languages and cultures': 1,
        'discrete math for comp science': 1,
        'discrete math for prblm solvng': 1,
        'diversified manufacturing i': 1,
        'diversified manufacturing ii': 1,
        'dollars and sense': 0.5,
        'earth and space science': 1,
        'economics w/emph free enterpr': 0.5,
        'electrical technology ii': 2,
        'electrical technology': 1,
        'energy & nat resources tech': 1,
        'energy, pwr, & trans sys': 1,
        'engineering design and presentation i': 1,
        'engineering design and presentation ii': 2,
        'engineering design and problem solving': 1,
        'engineering mathematics': 1,
        'engineering science': 1,
        'english iv': 1,
        'environmental systems-envirsys': 1,
        'equine science': 0.5,
        'extended career preparation': 1,
        'extended practicum in agriculture, food, and natural resources': 1,
        'extended practicum in animation': 1,
        'extended practicum in architectural design': 1,
        'extended practicum in audio/video production': 1,
        'extended practicum in business management': 1,
        'extended practicum in commercial photography': 1,
        'extended practicum in construction management': 1,
        'extended practicum in construction technology': 1,
        'extended practicum in distribution and logistics': 1,
        'extended practicum in education and training': 1,
        'extended practicum in graphic design and illustration': 1,
        'extended practicum in information technology': 1,
        'extended practicum in interior design': 1,
        'extended practicum in law, public safety, corrections, and security': 1,
        'extended practicum in manufacturing': 1,
        'extended practicum in marketing': 1,
        'extended practicum in masonry technology': 1,
        'extended practicum in printing and imaging technology': 1,
        'extended practicum in science, technology, engineering, and mathematics': 1,
        'extended practicum in transportation systems': 1,
        'family and community services': 1,
        'fashion design i lab': 1,
        'fashion design ii lab': 1,
        'fashion design ii': 1,
        'fashion design': 1,
        'fashion marketing': 0.5,
        'federal law enforcement and protective services': 1,
        'financial analysis': 1,
        'financial mathematics': 1,
        'firefighter i': 2,
        'firefighter ii': 3,
        'food processing': 1,
        'food science': 1,
        'food technology & safety': 1,
        'foreign svc & diplomacy': 1,
        'forensic science': 1,
        'forest & woodland ecosys': 1,
        'found of person fitness': 0.5,
        'game programming and design': 1,
        // 'music, general music 6': 1, //deletion edit 2024
        'general music, grade 7': 1,
        'general music, grade 8': 1,
        'global business': 0.5,
        'graphic design & illustration': 1,
        'graphic design and illustration i lab': 1,
        'graphic design and illustration ii lab': 1,
        'greenhouse operation and production': 1,
        'health 1': 0.5,
        'health informatics': 1,
        'health science clinical': 1,
        'health science': 1,
        'horticulture science': 1,
        'hospitality services': 2,
        'hotel management': 1,
        'human growth & develop': 1,
        'human resources mgt': 0.5,
        'hvac & refrigeration tech': 1,
        'ib art design sl-b': 1,
        'ib art/design hl': 1,
        'ib art/design sl-a': 1,
        'ib dance - hl': 1,
        'ib dance - sl': 1,
        'ib music hl': 2,
        'ib music sl': 2,
        'ib theatre arts hl': 1,
        'ib theatre arts sl': 1,
        'ib thtre/film - hl': 1,
        'ib thtre/film - sl': 1,
        'indep study in math': 1,
        'individual or team sports': 0.5,
        'instructional practices': 2,
        'insurance operations': 1,
        'integrated physics/chemistry': 1,
        'interior design': 1,
        'intermed act: comedy & improv': 1,
        'interpersonal studies': 0.5,
        'intr to cosmetology': 1,
        'introduction to transportation technology': 0.5,
        'introduction to welding': 1,
        'jazz improv i': 1,
        'jazz improv iv': 1,
        'landscp desgn & turf grass mgt': 0.5,
        'lang o/t english i - asl': 1,
        'lang o/t english ii - asl': 1,
        'lang o/t english iii - asl': 1,
        'lang o/t english iv - asl': 1,
        'lang other than eng *': 1,
        'law enforcement i': 1,
        'law enforcement ii': 1,
        'lifetime nutrit & wellnss': 0.5,
        'literary genres': 1,
        'livestock production': 1,
        'manufacturing engineering technology i': 1,
        'manufacturing engineering technology ii': 1,
        'masonry technology i': 2,
        'masonry technology ii': 2,
        'math appl in ag/food/& nat res': 1,
        'math models with applications': 1,
        'mathematics for medical professionals': 1,
        'medical microbiology': 1,
        'medical terminology': 1,
        'metal fabrication and machining i': 2,
        'metal fabrication and machining ii': 2,
        'mill & cabinetmaking tech': 2,
        'mobile application development': 1,
        'money matters': 1,
        'music & media communication ii': 1,
        'music & media communications i': 1,
        'music i band': 1,
        'music i choir': 1,
        'music i history': 1,
        'music i instrumental ensemble': 1,
        'music i jazz band': 1,
        'music i orchestra': 1,
        'music i theory': 1,
        'music i vocal ensemble': 1,
        'music ii band': 1,
        'music ii choir': 1,
        'music ii instrumental ensemble': 1,
        'music ii jazz band': 1,
        'music ii orchestra': 1,
        'music ii theory': 1,
        'music ii vocal ensemble': 1,
        'music iii band': 1,
        'music iii choir': 1,
        'music iii instrument ensemble': 1,
        'music iii jazz band': 1,
        'music iii orchestra': 1,
        'music iii vocal ensemble': 1,
        'music iv band': 1,
        'music iv choir': 1,
        'music iv instrumental ensemble': 1,
        'music iv jazz band': 1,
        'music iv orchestra': 1,
        'music iv vocal ensemble': 1,
        'music prod, level ii': 1,
        'music production i': 1,
        // 'music, grade 1': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 2': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 3': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 4': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 5': 1, // here because subject area is fine arts //deletion edit 2024
        'music, grade 6': 1,
        'music/band, grade 7': 1,
        'music/band, grade 8': 1,
        'music/band,departmental grd 6': 1,
        'music/choir, deptmental grd 6': 1,
        'music/choir, grade 7': 1,
        'music/choir, grade 8': 1,
        'music/inst ens, grd 7': 1,
        'music/instr ens, grd 8': 1,
        'music/jazz band, grd 7': 1,
        'music/jazz band, grd 8': 1,
        'music/orchestra, dept grd 6': 1,
        'music/orchestra, grd 7': 1,
        'music/orchestra, grd 8': 1,
        'musical theatre i': 1,
        'musical theatre ii': 1,
        'musical theatre iii': 1,
        'musical theatre iv': 1,
        'national security': 1,
        'networking lab': 1,
        'oil & gas prodction systems ii': 1,
        'oil & gas production systems i': 1,
        'oral interpretation i': 1,
        'oral interpretation ii': 1,
        'oral interpretation iii': 1,
        'paint and refinishing': 2,
        'pe3:pe f/mind/body/spirit': 1,
        'physical theatre i': 1,
        'piping & plumbing tech': 1,
        'planning and governance': 1,
        'playwriting i': 1,
        'playwriting ii': 1,
        'playwriting iii': 1,
        'political science i': 1,
        'political science ii': 1,
        'pracitcum culinary arts': 1,
        'practical writing skills': 1,
        'practicm local, st, & fed gov': 1,
        'practicum audio video prod': 1,
        'practicum fashion design ii': 3,
        'practicum health science': 1,
        'practicum hospit srvcs': 1,
        'practicum human svcs ii': 1,
        'practicum human svcs': 1,
        'practicum in ag,food & nat res': 2,
        'practicum in animation': 2,
        'practicum in architectural design': 2,
        'practicum in audio/video production': 2,
        'practicum in business management': 2,
        'practicum in commercial photography': 2,
        'practicum in constr mgt': 2,
        'practicum in construction technology': 2,
        'practicum in distribution and logistics': 2,
        'practicum in education and training': 2,
        'practicum in fashion design': 2,
        'practicum in graphic design and illustration': 2,
        'practicum in health science': 2,
        'practicum in information technology': 2,
        'practicum in interior design': 2,
        'practicum in local, state, and federal government': 2,
        'practicum in marketing': 2,
        'practicum in masonry technology': 2,
        'practicum in science, technology, engineering, and mathematics': 2,
        'practicum in transportation systems': 2,
        'practicum manufacturing': 2,
        'practicum print & imag tech ii': 1,
        'practicum print & imaging tech': 1,
        'prctcm law/pub safe/crrct/&sec': 2,
        'precision metal manufacturing ii': 2,
        'precision metal manufacturing': 1,
        'princ gov & public admin': 1,
        'princ of hospit & toursim': 1,
        'princ of trans, distr & logist': 1,
        'princ&elem of floral design': 1,
        'principles of agriculture, food, and natural resources': 1,
        'principles of applied engineering': 1,
        'principles of arch & constr': 1,
        'principles of biosciences': 1,
        'principles of business, marketing, and finance': 1,
        'principles of cosmetology design and color theory': 1,
        'principles of education and training': 1,
        'principles of health science': 1,
        'principles of info tech': 1,
        'principles of law, public safety, corrections, and security': 1,
        'principles of manufacturing': 1,
        'principles of technology': 1,
        'printing and imaging technology i lab': 1,
        'printing and imaging technology ii lab': 1,
        'prof standards in agribusiness': 0.5,
        'professional communications': 0.5,
        'project-based research': 1,
        'public mgt & admin': 1,
        'public speaking i': 1,
        'public speaking ii': 1,
        'public speaking iii': 1,
        'range eco & mgt': 1,
        'reading i': 1,
        'reading ii': 1,
        'reading iii': 1,
        'research/technical writing': 1,
        'revenue, tax, & regulation': 1,
        'robotics i': 1,
        'robotics ii': 1,
        'robotics programming & design': 1,
        'scenography i': 1,
        'scenography ii': 1,
        'scenography iii': 1,
        'scenography iv': 1,
        'scientific research & design': 1,
        'securities and investments': 1,
        'small animal management': 0.5,
        'small engine technology ii': 2,
        'small engine technology': 1,
        'social media marketing': 0.5,
        'solid state electronics': 1,
        'specl topics in lang & culture': 1,
        'sports & entertain marketing': 0.5,
        'stage cmbt/thtr mvmt': 1,
        'statistics and business decision making': 1,
        'technical theatre i': 1,
        'technical theatre ii': 1,
        'technical theatre iii': 1,
        'technical theatre iv': 1,
        'theatre & media communicatns i': 1,
        'theatre arts i': 1,
        'theatre arts ii': 1,
        'theatre arts iii': 1,
        'theatre arts iv': 1,
        'theatre departmentalized grd 6': 1,
        'theatre production i': 1,
        'theatre production ii': 1,
        'theatre production iii-th3prod': 1,
        'theatre production iv': 1,
        // 'theatre, grade 1': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 2': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 3': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 4': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 5': 1, // here because subject area is fine arts //deletion edit 2024
        'theatre, grade 6': 1,
        'theatre, grade 7': 1,
        'theatre, grade 8': 1,
        'touch sys data entry': 0.5,
        'trans systems mgt': 1,
        'travel & tourism mgt': 1,
        'vet medical applications': 1,
        'video game design i': 1,
        'virtual business': 0.5,
        'visual media analysis and prod': 0.5,
        'web communications': 0.5,
        'web design': 1,
        'web game development': 1,
        'web technologies': 1,
        'welding ii lab': 1,
        'wildlife, fish & eco mgt': 1,
        'world health research': 1,
        advertising: 0.5,
        animation: 1,
        astronomy: 1,
        biotechnology: 1,
        chemistry: 1,
        entrepreneurship: 1,
        humanities: 1,
        networking: 1,
        pathophysiology: 1,
        pharmacology: 1,
        photojournalism: 1,
        physics: 1,
        precalculus: 1,
        welding: 2,
        /* new courses added 2018-06-26 - electives */
        "acting methods": 1,
        "acting styles:classic/commedia": 1,
        "acting styles:improv/monologue": 1,
        "acting styles:realism/post-war": 1,
        "adv aircraft technology": 1,
        "adv architectural design": 1,
        "adv audio video production": 1,
        "adv automotive technology": 1,
        "adv building maint tech": 1,
        "adv collis repair & refinish": 1,
        "adv electrical technology": 1,
        "adv eng design & presentation": 1,
        "adv fashion design": 1,
        "adv flexible manufacturing": 1,
        "adv journalism: lit mag ii": 1,
        "adv journalism: lit mag iii": 1,
        "adv journalism: lit magazine i": 1,
        "adv piping & plumbing tech": 1,
        "adv precision metal manuf": 1,
        "adv print & imaging tech": 1,
        "adv small engine technology": 1,
        "advan interior design": 1,
        "advance via indivd determn iii": 1,
        "advance via indivd determn iv": 1,
        "advance via individ determn i": 1,
        "advance via individ determn ii": 1,
        "advanced constr technology": 1,
        "advanced electronics": 1,
        "advanced environmental tech": 1,
        "advanced floral design": 1,
        "advanced health education": 0.5,
        "advanced shipboard engineering": 1,
        "advertising & sales promo": 1,
        "aerospace engineering": 1,
        "ag fac desgn & fabr": 1,
        "ap art history": 1,
        "ap comparative govt & politics": 0.5,
        "ap english language and comp": 1,
        "ap english literature and comp": 1,
        "ap european history": 1,
        "ap human geography": 1,
        "ap physics 1: algebra based": 1,
        "ap physics 2: algebra based": 1,
        "ap physics c": 1,
        "ap physics c: electr&magnetism": 1,
        "ap physics c: mechanics": 1,
        "ap research": 1,
        "ap seminar": 1,
        "ap studio art:2-dim dsgn portf": 1,
        "ap studio art:3-dim dsgn portf": 1,
        "ap studio art:drwing portfolio": 1,
        "ap world history": 1,
        "applied math for tech profsnls": 1,
        "architectural design": 1,
        "art i - art appreciation": 1,
        "art i-art & media communica. i": 1,
        "art ii - design i": 1,
        "art ii - digital art & media i": 1,
        "art ii": 1,
        "art ii, ceramics i": 1,
        "art ii, drawing i": 1,
        "art ii, fibers i": 1,
        "art ii, jewelry i": 1,
        "art ii, painting i": 1,
        "art ii, photography i": 1,
        "art ii, printmaking i": 1,
        "art ii, sculpture i": 1,
        "art ii-art&media communica. ii": 1,
        "art iii - design ii": 1,
        "art iii": 1,
        "art iii, ceramics ii": 1,
        "art iii, drawing ii": 1,
        "art iii, fibers ii": 1,
        "art iii, jewelry ii": 1,
        "art iii, painting ii": 1,
        "art iii, photography ii": 1,
        "art iii, printmaking ii": 1,
        "art iii, sculpture ii": 1,
        "art iii-digital art & media ii": 1,
        "art iv - design iii": 1,
        "art iv": 1,
        "art iv, ceramics iii": 1,
        "art iv, drawing iii": 1,
        "art iv, fibers iii": 1,
        "art iv, jewelry iii": 1,
        "art iv, painting iii": 1,
        "art iv, photography iii": 1,
        "art iv, printmaking iii": 1,
        "art iv, sculpture iii": 1,
        "art iv-digital art & media iii": 1,
        "automotive technology": 1,
        "aviation honors ground school": 1,
        "baking and pastry arts lab": 1,
        "baking and pastry arts": 1,
        "barbering i": 3,
        "biomedical innovation": 1,
        "biotechnology engineer": 1,
        "braille": 1,
        "investigating careers 1st time": 1,
        "investigating careers 2nd time": 1,
        "investigating careers 3rd time": 1,
        "investigating careers 4th time": 1,
        "civil eng & architectur": 1,
        "colge prep course mathematics": 1,
        "colge prep crse engl lang arts": 1,
        "college transition": 1,
        "comp integrated manuf": 1,
        "comprehensive wellness i": 1,
        "comprehensive wellness ii": 1,
        "computer scince & sftwre engin": 1,
        "concepts of eng & tech": 1,
        "cosmetlgy facial spec": 1,
        "cosmetlgy manicure spec": 1,
        "cosmetlgy sham & cond spec": 1,
        "cyber citizenship": 1,
        "dance - middle school 1": 1,
        "dance - middle school 2": 1,
        "dance - middle school 3": 1,
        "dance i - ballet i": 1,
        "dance i - dance production i": 1,
        "dance i - dance theory i": 1,
        "dance i - dance wellness i": 1,
        "dance i - jazz i": 1,
        "dance i - tap i": 1,
        "dance i - world dance forms i": 1,
        "dance i, principles of dance i": 1,
        "dance i-dance & media comm i": 1,
        "dance i-dance comp/improv i": 1,
        "dance i-modern/contemporary i": 1,
        "dance i-performance/ensemble i": 1,
        "dance ii - ballet ii": 1,
        "dance ii - dance production ii": 1,
        "dance ii - dance wellness ii": 1,
        "dance ii - jazz ii": 1,
        "dance ii - tap ii": 1,
        "dance ii, dance theory ii": 1,
        "dance ii, dance&media comm ii": 1,
        "dance ii, principls of dnce ii": 1,
        "dance ii-dance comp/improv ii": 1,
        "dance ii-modern/contemp ii": 1,
        "dance ii-perform/ensemble ii": 1,
        "dance ii-world dance forms ii": 1,
        "dance iii - ballet iii": 1,
        "dance iii - dance history i": 1,
        "dance iii - dance theory iii": 1,
        "dance iii - dance wellness iii": 1,
        "dance iii - jazz iii": 1,
        "dance iii - tap iii": 1,
        "dance iii, perform/ensem iii": 1,
        "dance iii, princip of dnce iii": 1,
        "dance iii-danc comp/improv iii": 1,
        "dance iii-dance production iii": 1,
        "dance iii-modern/contemp iii": 1,
        "dance iii-wrld dance forms iii": 1,
        "dance iv - ballet iv": 1,
        "dance iv - dance production iv": 1,
        "dance iv - dance theory iv": 1,
        "dance iv - dance wellness iv": 1,
        "dance iv - jazz iv": 1,
        "dance iv, principls of dnce iv": 1,
        "dance iv, world dance forms iv": 1,
        "dance iv-dance comp/improv iv": 1,
        "dance iv-modern/contemp iv": 1,
        "dance iv-perform/ensemble iv": 1,
        "data acquisition & analysis": 1,
        "database fundamental": 1,
        "database programming": 1,
        "dc dircuits": 1,
        "digital fundamentals": 1,
        "digital image processing": 1,
        "disaster response": 1,
        "dosage calculations": 1,
        "driver and safety education": 0.5,
        "driver education": 0.5,
        "economics adv studies": 0.5,
        "electricity and magnetism": 0.5,
        "electronics": 1,
        "emergency med technician-basic": 2,
        "eng design & develop": 1,
        "eng design & presentation": 1,
        "eng: the digit futr": 1,
        "exercise physiology": 1,
        "college and career readiness": 1,
        "fine arts, subst, com-bsed pgm": 1,
        "flexible manufacturing": 1,
        "forensic psychology": 1,
        "functional fitness": 1,
        "fundamentals of comp science": 1,
        "gateway to technology i": 1,
        "gateway to technology ii": 1,
        "gateway to technology iii": 1,
        "general employability skills": 1,
        "geographic info sys": 1,
        "gifd & tal ind stud mentor iii": 1,
        "gifd & tal ind stud mentor iv": 1,
        "gft&tal intdisc std mentr smnr": 1,
        "gft&tal intdisc stud smnr iii": 1,
        "hair braiding specialist": 1,
        "health i": 0.5,
        "human body systems": 1,
        "ib business & mgt i": 1,
        "ib business & mgt ii": 1,
        "ib computer science, highr lvl": 1,
        "ib computer science, std level": 1,
        "ib dance i standard level": 1,
        "ib dance ii higher level": 1,
        "ib economics, higher level": 1,
        "ib economics, standard level": 1,
        "ib english iii": 1,
        "ib english iv": 1,
        "ib further mthematics high lvl": 1,
        "ib geography, higher level": 1,
        "ib geography, standard level": 1,
        "ib hist, standard level ibhist": 1,
        "ib hist: americas, higher levl": 1,
        "ib hist: europe, higher level": 1,
        "ib info tech in a globl soc sl": 1,
        "ib mathematical studies stan.": 1,
        "ib mathematics higher level": 1,
        "ib mathematics standard level": 1,
        "ib philosophy": 1,
        "ib psychology, higher level": 1,
        "ib psychology, standard level": 1,
        "ib theory of knowledge": 1,
        "ib visual arts higher level": 1,
        "ib visual arts standard level": 1,
        "ib world religions standrd lvl": 2,
        "ind std in eng: hbr scr & ntst": 1,
        "ind stdy in evlv/emrg tchs 1st": 1,
        "indep study in eng:heb scrip": 1,
        "indep study in eng:new test": 1,
        "indep study/english": 1,
        "indep study/journalism": 1,
        "indep study/speech": 1,
        "ind study in tech app 3rd time": 1,
        "ind study in tech aps 1st time": 1,
        "ind study in tech aps 2nd time": 1,
        "integ abil:ex for create grwth": 0.5,
        "internetworking tech i": 1,
        "internetworking tech ii": 1,
        "ib film higher level": 2,
        "ib film standard level": 2,
        "intro to engin design": 1,
        "intro to process technology": 1,
        "intro to renewable energy": 1,
        "intro to shipboard engineering": 1,
        "introduction to american law": 1,
        "legal research and writing": 1,
        "linear algebra": 0.5,
        "logic1": 0.5,
        "logic2": 0.5,
        "logist, plan & mgt sys": 1,
        "making connections i": 0.5,
        "manufacturing engineering": 1,
        "maritime science i": 1,
        "maritime science ii": 1,
        "marketing dynamics": 1,
        "mathematics for medical pros": 1,
        "medical biotechnology": 1,
        "medical interventions": 1,
        "meth of acad &prsonal sccess i": 1,
        "meth of acadmic & pers succ ii": 1,
        "mexican american studies": 1,
        "modern physics": 1,
        "movement for the actor": 1,
        "multivariable calculus": 1,
        "music i - guitar i": 1,
        "music i - harp i": 1,
        "music i - jazz improvisation i": 1,
        "music i - mariachi i": 1,
        "music i - piano i": 1,
        "music i, applied music i": 1,
        "music i, band i": 1,
        "music i, choir i": 1,
        "music i, instrumental ensem i": 1,
        "music i, jazz ensemble i": 1,
        "music i, orchestra i": 1,
        "music i, vocal ensemble i": 1,
        "music i-world music ensemble i": 1,
        "music ii - guitar ii": 1,
        "music ii - harp ii": 1,
        "music ii - jazz improv ii": 1,
        "music ii - mariachi ii": 1,
        "music ii - piano ii": 1,
        "music ii instrumental ensem ii": 1,
        "music ii, applied music ii": 1,
        "music ii, band ii": 1,
        "music ii, choir ii": 1,
        "music ii, jazz ensemble ii": 1,
        "music ii, orchestra ii": 1,
        "music ii, vocal ensemble ii": 1,
        "music ii-wrld music ensembl ii": 1,
        "music iii - applied music iii": 1,
        "music iii - guitar iii": 1,
        "music iii - harp iii": 1,
        "music iii - jazz improv iii": 1,
        "music iii - mariachi iii": 1,
        "music iii - piano iii": 1,
        "music iii instrumntl ensem iii": 1,
        "music iii, band iii": 1,
        "music iii, choir iii": 1,
        "music iii, jazz ensemble iii": 1,
        "music iii, orchestra iii": 1,
        "music iii, vocal ensemble iii": 1,
        "music iii-wrld music ensbl iii": 1,
        "music iv - applied music iv": 1,
        "music iv - guitar iv": 1,
        "music iv - harp iv": 1,
        "music iv - jazz improv iv": 1,
        "music iv - mariachi iv": 1,
        "music iv - piano iv": 1,
        "music iv, band iv": 1,
        "music iv, choir iv": 1,
        "music iv, instrumentl ensem iv": 1,
        "music iv, jazz ensemble iv": 1,
        "music iv, orchestra iv": 1,
        "music iv, vocal ensemble iv": 1,
        "music iv-wrld music ensembl iv": 1,
        "music studies - music busn i": 1,
        "music studies - music comp i": 1,
        "music studies - music comp ii": 1,
        "music studies - music prod i": 1,
        "music studies - music prod ii": 1,
        "music studies - music theory i": 1,
        "music studies-music apprec. i": 1,
        "music studies-music apprec. ii": 1,
        "music studies-music theory ii": 1,
        "music studies-music&med comm i": 1,
        "music studies-music&med commii": 1,
        "navigtng life for stdnts deaf": 1,
        "number theory": 0.5,
        "occuptnl sfty & environ tech i": 1,
        "occuptnl sfty &environ tech ii": 1,
        "oil and gas production i": 1,
        "oil and gas production ii": 1,
        "oil and gas production iii": 1,
        "parent ed f/schl age prnts i": 1,
        "parent ed f/schl age prnts ii": 1,
        "path college career i": 1,
        "path college career ii": 1,
        "path college career iii": 1,
        "path college career iv": 1,
        "peacekeepers peer mediation i": 1,
        "peacekeepers peer mediation ii": 1,
        "peer assistance and leadersh 1": 1,
        "peer assistance and leadersh 2": 1,
        "peer asst for std w/dsabil ii": 0.5,
        "peer asst for std wth dsabil i": 0.5,
        "peer coaching for students i": 0.5,
        "peer coaching for students ii": 0.5,
        "peer coaching for students iii": 1,
        "peer coaching for students iv": 1,
        "peers accepting,lrning,shar i": 1,
        "peers accepting,lrning,shar ii": 1,
        "personal financial literacy": 0.5,
        "petrochem sfty, hlth & environ": 1,
        "physical theatre ii": 1,
        "planet earth": 1,
        "pracitcum culinary arts ii": 1,
        "practcm in ag,food&nat res ii": 1,
        "practcm science/tech/eng/&math": 1,
        "practic graph dsgn & illust ii": 1,
        "practicm local,st& fed gov ii": 1,
        "practicum audio video prod ii": 1,
        "practicum business mgt ii": 1,
        "practicum graph desgn & illust": 1,
        "practicum health science ii": 1,
        "practicum hospit srvcs ii": 1,
        "practicum in archtect desgn ii": 1,
        "practicum in constr mgt ii": 1,
        "practicum in inter design ii": 1,
        "practicum manufacturing ii": 1,
        "practicum marketin dynamics ii": 1,
        "practicum marketing dynamics": 1,
        "practicum trans, dist & log ii": 1,
        "practicum trans, dist & log": 1,
        "practm scinc/tech/eng/&math ii": 1,
        "prctm law/pub saf/crct/&sec ii": 1,
        "princ arts/aud vid tech & comm": 1,
        "princ law, pub safe,corrt &sec": 1,
        "princ of busin, mark, & finan": 1,
        "princ of cos dsgn & clr theory": 1,
        "principles of cyber security": 1,
        "principles of engineering": 1,
        "principles of maritime science": 1,
        "principles of oil & gas prdctn": 1,
        "princpl of ag, food, & nat res": 1,
        "princpls of biomed science": 1,
        "print & imaging tech": 1,
        "problems and solutions ii": 1,
        "problems and solutions": 1,
        "psychology": 0.5,
        "radio broadcasting i": 1,
        "radio broadcasting ii": 1,
        "raster based geo info sys": 1,
        "reconnecting youth": 0.5,
        "res officers train": 1,
        "research in info tech sol ii": 1,
        "research in info tech sol": 1,
        "research methods humanities": 1,
        "restaurant management": 1,
        "retailing & e-tailing": 1,
        "robotics and automation": 1,
        "scien research & design iii": 1,
        "science and tech": 1,
        "science-inst of high ed endrsd": 1,
        "scientific research & desgn ii": 1,
        "security services": 1,
        "soc stud research meth": 0.5,
        "social intell for esl students": 1,
        "social std adv stdys": 1,
        "sociology": 0.5,
        "spc top soc stu:hb scr/old tst": 0.5,
        "spcl soc stud tpcs hebrw/ntest": 1,
        "spec top soc stud: new test": 0.5,
        "spec topic in soc stud": 0.5,
        "spec topics in soc stud": 0.5,
        "speech & language development": 1,
        "sports medicine i": 1,
        "sports medicine ii": 1,
        "sports medicine iii": 1,
        "stat & risk mgt": 1,
        "statistics": 1,
        "strategic learn f/hs math": 1,
        "strength bank: rlationshp init": 1,
        "student leadership": 1,
        "team sport officiating": 1,
        "tech theatr ii-dsgn for theatr": 1,
        "tech theatr ii-mkeup for theat": 1,
        "tech theatr iii-adv dsgn theat": 1,
        "tech theatr iii-mkup for theat": 1,
        "tech theatr iv-adv cstume cnst": 1,
        "tech theatr iv-adv desn theatr": 1,
        "tech theatre ii-costume const": 1,
        "tech theatre ii-theater mgt": 1,
        "tech theatre iii-adv cst const": 1,
        "tech theatre iii-adv light&snd": 1,
        "tech theatre iii-adv stagecrft": 1,
        "tech theatre iii-adv theat mgt": 1,
        "tech theatre iv-adv light&snd": 1,
        "tech theatre iv-adv stagecraft": 1,
        "tech theatre iv-adv theat mgt": 1,
        "technical theatre ii-lgt & snd": 1,
        "technical theatre ii-stagecrft": 1,
        "teen leadership": 1,
        "telecomm & networking": 1,
        "theatre i, theatre arts i": 1,
        "theatre i, theatre prod i": 1,
        "theatre i-theatre&media comm i": 1,
        "theatre ii, theatre arts ii": 1,
        "theatre ii, theatre prod ii": 1,
        "theatre ii-theatr&media com ii": 1,
        "theatre iii - directing i": 1,
        "theatre iii - playwriting i": 1,
        "theatre iii, theatre arts iii": 1,
        "theatre iii, theatre prod iii": 1,
        "theatre iv - directing ii": 1,
        "theatre iv - playwriting ii": 1,
        "theatre iv, theatre arts iv": 1,
        "theatre iv, theatre prod iv": 1,
        "tx prefreshman eng pgm iii": 1,
        "tx prefreshman eng pgm iv": 1,
        "video game design ii": 1,
        "video game design iii": 1,
        "viticulture": 1,
        "young leaders for healthy chng": 0.5,
        "graphic dsgn & illustration i": 1,
        "project-based research 2nd tme": 1,
        "dance, level iv, ib dance ii": 1,
        "prctum in culinary arts 1st tm": 2,
        "construction management i": 2,
        "small engine technology i": 1,
        "auto technology ii: auto servc": 2,
        "welding ii": 2,
        "digital media": 1,
        "parenting education i": 1,
        "adv energy & natrl resrce tech": 1,
        "plumbing technology ii": 2,
        "commercial photography i": 1,
        "animation i": 1,
        "prctm prnt & image tech 1st tm": 2,
        "precision metal mnufacturng ii": 2,
        "welding i": 2,
        "principles of appld enginering": 1,
        "horticultural science": 1,
        //"music studies, ib music hl": 1, //deletion edit 2024
        "building maintenance tech i": 2,
        "audio/video production ii": 1,
        "computer programming ii": 1,
        "prctm grph dsgn & ilust 1st tm": 2,
        "collision repair": 2,
        "engineering dsgn & presentn i": 1,
        "distribution and logistics": 1,
        "interior design i": 1,
        "practicum in fashn dsgn 2nd tm": 2,
        "graphic dsgn & illustration ii": 1,
        "nail care, enhncemnts &spa svc": 2,
        "metal fbrication & machining i": 2,
        "art, ib visual arts hl": 2,
        "computer tech prac 1st tme tkn": 2,
        "meth of acad & persnal success": 1,
        "ib language studies a1 hl": 1,
        "prctm architecture dsgn 2nd tm": 2,
        "fed law enfrcemnt&protect svcs": 1,
        "commercial photography ii": 1,
        "stat & busness decision making": 1,
        "agrcltr structure design & fab": 1,
        "printing & imaging technolgy i": 1,
        "prct sci,tech eng&math 1st tme": 2,
        "practicum in human svcs 1st tm": 2,
        "computer programming i": 1,
        "prctm local,st&fed govt 2nd tm": 2,
        "practicum in marketing 2nd tme": 2,
        "prctm grph dsgn & ilust 2nd tm": 2,
        "robotics": 1,
        "gateway to tech": 1,
        "construction management ii": 2,
        "mgt of transportation systems": 1,
        "art, ib visual arts sl": 2,
        "energy & pwr of trnsprt systms": 1,
        "engineering dsgn & presentn ii": 2,
        "practicum aud/vid prod 1st tme": 2,
        "video game programming": 1,
        "practicum in human svcs 2nd tm": 2,
        "landscape design & management": 0.5,
        "fashion design i": 1,
        "interior design ii": 2,
        "audio/video production i": 1,
        "theatre, ib theatre hl": 2,
        "prctm in manufacturing 2nd tme": 2,
        "advancd video game programming": 1,
        "prctum info technology 1st tme": 2,
        "auto tech i: mnt & lght repair": 2,
        "pctm ag,food,nat resrc 2nd tme": 2,
        "printing & imaging technlgy ii": 1,
        "parenting education ii": 1,
        "construction technology i": 2,
        "floral design": 1,
        "prc law,pubsft,cor&sfty 2nd tm": 2,
        "pctm interior design": 1,
        "plumbing technology i": 1,
        "prctm prnt & image tech 2nd tm": 2,
        "precision metal mnufacturng i": 2,
        // "music studies, ib music sl": 1, //deletion edit 2024
        "prct sci,tech eng&math 2nd tme": 2,
        "hvac & refrig technology i": 1,
        "metal fbrication, machining ii": 2,
        "practicum in busin mgt 2nd tme": 2,
        "animation ii": 1,
        "prnc arts, aud/vid tech & comm": 1,
        "biotechnology i": 1,
        "project-based research 1st tme": 1,
        "prctcm construction mgt 2nd tm": 2,
        "prctcm construction mgt 1st tm": 2,
        "esthetics": 2,
        "prc law,pubsft,cor&sfty 1st tm": 2,
        "prctm in manufacturing 1st tme": 2,
        "health science theory": 1,
        "pctm ag,food,nat resrc 1st tme": 2,
        "dance, level iii, ib dance i": 1,
        "hvac & refrig technology ii": 2,
        "ib language studies a1 sl": 1,
        "prctum in culinary arts 2nd tm": 2,
        "prctm local,st&fed govt 1st tm": 2,
        "practicum in marketing 1st tme": 2,
        "building maintenance tech ii": 2,
        "prctm in hspitalty svcs 2nd tm": 2,
        "prctm in hspitalty svcs 1st tm": 2,
        "practicum aud/vid prod 2nd tme": 2,
        "envronmntl sustainabilty pltw)": 1,
        "theatre, ib theatre sl": 2,
        "electrical technology i": 1,
        "prctm in hlth science 1st time": 2,
        "prctum info technology 2nd tme": 2,
        "prctm in hlth science 2nd time": 2,
        "mnfg engineering technology i": 1,
        "applied math for tech profnals": 1,
        "auto tech ii:auto svc/adv lab": 3,
        "barbering ii": 3,
        "career prep i/ext career prep": 3,
        "career prep ii/ext career prep": 3,
        "coca-cola valued youth tutorng": 1,
        "content-based esol for science": 1,
        "engl i for speakrs of oth lang": 1,
        "fnd of intnsv lang acqu/suprt": 1,
        "ind stdy in evlv/emer tchs 2nd": 1,
        "ind stdy in evlv/emer tchs 3rd": 1,
        "integrated mathematics i*ector": 1,
        "lcc-career & tech ed-grd 9-12": 1,
        "lcc-eng lang arts, grd 9-12": 1,
        "lcc-fine arts-grd 9-12": 1,
        "lcc-health-grd 9-12": 1,
        "lcc-mathematics- grd 9-12": 1,
        "lcc-other sec subject-grd 9-12": 1,
        "lcc-pe- grd 9-12": 1,
        "lcc-science-grd 9-12": 1,
        "lcc-social studies-grd 9-12": 1,
        "lcc-tech applications-grd 9-12": 1,
        "making connections iii": 0.5,
        "math-inst of higher edu endrsd": 1,
        "newcmer eng lang developmnt a": 1,
        "newcmer eng lang developmnt b": 1,
        "orientation and mobility": 1,
        "journalism": 1,
    }
};
//# sourceMappingURL=electives.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/electives.js
// module id = 442
// module chunks = 22